import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';


//Components

import Logo from '../navbarComponents/Logo';

import LoadingSpinner from '../loadingSpinner/LoadingSpinner';
import Error from '../bodyComponents/Error';


//Styling
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faEnvelope, faCog } from '@fortawesome/free-solid-svg-icons';


const Navbar = ({ isNavOpen, toggleNav }) => {

  // console.log('hasMessagesAtAll in navBar', hasMessagesAtAll)

  const { t } = useTranslation();



  const navigate = useNavigate();

  const [isLargeScreen, setIsLargeScreen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [showSections, setShowSections] = useState(false);



  const navbarRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isLargeScreen &&
        navbarRef.current &&
        !navbarRef.current.contains(event.target)
      ) {
        // setShowSections({
        //   admin: false,
        //   profile: false,
        //   social: false,
        //   moderator: false,
        //   protectedRoutes: false,
        //   posts: false,
        // });
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isLargeScreen]);

  // Effect to detect window size
  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1025);
    };

    // Check screen size on mount
    handleResize();

    // Add event listener to detect resize
    window.addEventListener('resize', handleResize);

    // Cleanup event listener on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Reset dropdowns when navbar closes
  useEffect(() => {
    if (!isNavOpen) {
      // setShowSections({ admin: false, profile: false }); // Close all dropdowns
    }
  }, [isNavOpen]); // This effect runs every time `isNavOpen` changes


  // Navigate to a specific path
  const handleNavigate = (path) => {
    navigate(path);

    // Only toggle the navbar (close it) if the screen width is <= 580px
    if (isNavOpen && window.innerWidth <= 580) {
      toggleNav(); // Close the navbar when a link is clicked in mobile view
    }

    // Close dropdowns whenever navigating
    if (window.innerWidth > 1024) {
      // setShowSections({ admin: false, profile: false, protectedRoutes: false });
    }
  };

  // Toggle individual dropdown sections and close others
  const toggleSection = (section) => {
    setShowSections((prevState) => ({

      // Close all other sections, only toggle the clicked one
      // admin: section === 'admin' ? !prevState.admin : false,
      // profile: section === 'profile' ? !prevState.profile : false,
      // social: section === 'social' ? !prevState.social : false,
      // posts: section === 'posts' ? !prevState.posts : false,
      // moderator: section === 'moderator' ? !prevState.moderator : false,
      // protectedRoutes: section === 'protected_routes' ? !prevState.protectedRoutes : false,
    }));
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <Error isNavOpen={isNavOpen} error={error} />
  }




  return (
    <div ref={navbarRef} className={`navbar ${isNavOpen ? 'navbar-open' : ''}`} data-testid="navbar">

      {isLargeScreen && (
        <Logo handleNavigate={handleNavigate} />
      )}


      {<div className='nav-item' onClick={() => handleNavigate('/')}>
        {t('Home.navbar.home')}</div>}

      {<div className='nav-item' onClick={() => handleNavigate('/plans')}>
        {t('Home.navbar.plans')}
      </div>}
      {<div className='nav-item' onClick={() => handleNavigate('/demo')}>
        {t('Home.seeItInAction')}
      </div>}

            {<div className='nav-item' onClick={() => handleNavigate('/setup')}>
        {t('Home.navbar.setup')}
      </div>}

      {<div className='nav-item' onClick={() => handleNavigate('/start')}>
        {t('Home.navbar.getStarted')}
      </div>}



    </div >
  );
};

export default Navbar;
